<!-- src/components/home/CategoryCard.vue -->
<template>
  <section class="category-card card">
    <!-- Левая часть -->
    <div class="left">
      <div class="left-content">
        <h2 class="title">{{ title }}</h2>

        <div class="actions">
          <!-- Primary action: customizable label / route -->
          <BaseButton :to="primaryRoute">
            <template #icon-right>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 5l7 7-7 7" stroke="#222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </template>
            {{ primaryLabel }}
          </BaseButton>

          <!-- Secondary DB button: show only if showDatabase prop true -->
          <BaseButton v-if="showDatabase" to="/database">
            База данных
          </BaseButton>
        </div>
      </div>

      <!-- картинка внизу -->
      <img :src="imgSrc" alt="" class="planet" />
    </div>

    <!-- Правая часть -->
    <div class="right">
      <div class="blocks-grid">
        <div v-for="(b, i) in blocks" :key="i" class="block">
          <h3 class="block-title">{{ b.title }}</h3>
          <p class="block-text">{{ b.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseButton from '@/components/ui/BaseButton.vue'
export default {
  name: 'CategoryCard',
  components: { BaseButton },
  props: {
    title: { type: String, required: true },
    img: { type: String, default: '' },
    blocks: { type: Array, default: () => [] },

    // new props:
    // primaryRoute: string or object for router-link `to`
    primaryRoute: { type: [String, Object], default: '/map' },
    // primaryLabel: label text for main button
    primaryLabel: { type: String, default: 'Исследовать на карте' },
    // whether to show second button "База данных" (по заданию — убрать => default false)
    showDatabase: { type: Boolean, default: false }
  },
  computed: {
    imgSrc() {
      return this.img || require('@/assets/planet.png')
    }
  }
}
</script>

<style scoped>
.category-card {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 32px;
  padding: 32px;
  background: var(--card-color, #2f2f2f);
  border-radius: 20px;
  min-height: 200px;
  align-items: stretch;
  position: relative;
}

/* Левая часть */
.left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.left-content { text-align: right; }

.title {
  font-size: 36px;
  margin: 0 0 20px;
  color: var(--hp-font-color, #f0f0f0);
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
}

.planet { width: 100%; height: auto; object-fit: cover; border-radius: 12px; margin-top: 20px; }

/* Правая часть */
.blocks-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 12px;
  height: 100%;
}

.block {
  background: rgba(0, 0, 0, 0.25);
  padding: 20px;
  border-radius: 14px;
  color: var(--hp-font-color, #f0f0f0);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}
.block-title { margin: 0 0 8px; font-size: 22px; font-weight: 700; }
.block-text { margin: 0; font-size: 20px; line-height: 1.5; opacity: 0.9; }
</style>
